module.exports = {
    /**
        * Interpolate hex colors between the two hex colors
        * 
        * @param {string} a - starting color
        * @param {string} b - ending color
        * @param {number} amount - interval (optional)
        */
    lerpColor: (a, b, amount) => {
        var ah = parseInt(a.replace(/#/g, ''), 16),
            ar = ah >> 16, ag = ah >> 8 & 0xff, ab = ah & 0xff,
            bh = parseInt(b.replace(/#/g, ''), 16),
            br = bh >> 16, bg = bh >> 8 & 0xff, bb = bh & 0xff,
            rr = ar + amount * (br - ar),
            rg = ag + amount * (bg - ag),
            rb = ab + amount * (bb - ab);

        return '#' + ((1 << 24) + (rr << 16) + (rg << 8) + rb | 0).toString(16).slice(1);
    },
    /**
    * Create an array of equidistant values
    * 
    * @param {number} start - starting value
    * @param {number} nvalues - how many values
    * @param {number} interval - interval (optional)
    */
    linSpace: (start, nvalues, interval) => {
        if (typeof interval === "undefined") { interval = 0; }
        var i;
        var r = [];
        for (i = 0; i < nvalues; i++) {
            r.push(start + (i * interval));
        }
        return r;
    },
    /**
    * Clamp number num between min, max
    * 
    * @param {number} num - input number
    * @param {number} min - minimum value
    * @param {number} max - maximum number
    */
    clamp: (num, min, max) => {
        return Math.min(Math.max(num, min), max);
    }
}